import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/app/store";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    {/* React Hot Toast's Toaster Component */}
    <Toaster
      position="top-center"
      toastOptions={{
        success: {
          style: { background: "#4caf50", color: "#fff" },
        },
        error: {
          style: { background: "#f44336", color: "#fff" },
        },
      }}
    />
  </Provider>
);
